import { cn } from '../cn.js';

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  /** The keys, in press order: `['⌘', 'K']`. */
  readonly keys: readonly string[];
}

/**
 * A keyboard shortcut, shown where the action is.
 *
 * A shortcut nobody can see is a shortcut nobody learns, which is most of why command palettes
 * get opened by mouse. Each key is its own `<kbd>` so a screen reader reads "command, K" rather
 * than one run-on token, and the separator is a real character rather than a border trick.
 */
export function Kbd({ className, keys, ...props }: KbdProps) {
  return (
    <span className={cn('inline-flex items-center gap-(--space-xs)', className)} {...props}>
      {keys.map((key) => (
        <kbd
          key={key}
          className={cn(
            'inline-flex min-w-(--size-icon-md) items-center justify-center',
            'rounded-(--radius-sm) border border-(--color-border) bg-(--color-surface-sunken)',
            'px-(--space-xs) font-mono text-(length:--font-size-caption) text-(--color-text-secondary)',
          )}
        >
          {key}
        </kbd>
      ))}
    </span>
  );
}
